import Backbone from 'backbone';

var CurrentUserInfo = Backbone.Model.extend({
    url: function() {
        return '/modern/currentuser-service/user/info'; // This end point is from modern-web, not the API
    },

    getCustomerId: function() {
        return this.get('customerId');
    },

    getUsername: function() {
        return this.get('username');
    },

    getEmailAddress: function() {
        return this.get('emailAddress');
    },

    getSocialNetwork: function() {
        return this.get('socialNetwork');
    },

    getSocialIcon: function() {
        return this.get('socialIcon');
    }
});

export default CurrentUserInfo;
